import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

const loadState = (): 'bookAppointment' | 'manageOrganizations' | null => {
    const savedState = localStorage.getItem('target');
    return savedState ? savedState as 'bookAppointment' | 'manageOrganizations' : null;
};

const initialState: 'bookAppointment' | 'manageOrganizations' | null = loadState();

const targetSlice = createSlice({
    name: 'target',
    initialState,
    reducers: {
        setTarget: (state, action: PayloadAction<'bookAppointment' | 'manageOrganizations'>) => {
            localStorage.setItem('target', action.payload);
            return action.payload;
        },
        removeTarget: (state) => {
            localStorage.removeItem('target');
            return null;
        },
    },
});

export const { setTarget, removeTarget } = targetSlice.actions;
export default targetSlice.reducer;
export const selectTarget = (state: RootState) => state.target;